import { nth } from 'lodash';
import { useGetList } from 'react-admin';
import { AVATARS } from '@/utils/CONST';
import { Avatar } from '@/utils/types';

interface Params {
    filters: { [key: string]: any };
    enabled?: boolean;
}

interface Output {
    avatars: Avatar[];
    firstAvatar: Avatar | undefined;
    isLoading: boolean;
    refetch: any;
}

const useGetAvatarsV2 = ({ filters, enabled = true }: Params): Output => {
    const {
        data = [],
        isLoading,
        refetch,
    } = useGetList<Avatar>(
        AVATARS,
        {
            filter: filters,
            meta: {
                api: 'v2',
            },
        },
        {
            enabled,
        },
    );

    const firstAvatar = nth(data, 0) as Avatar | undefined;

    return {
        avatars: data,
        firstAvatar,
        isLoading,
        refetch,
    };
};

export default useGetAvatarsV2;
